/** @format */

import {
	AppProductReviewState,
	ReviewSummary,
	selectAIReviewSummary,
	selectProductReviewProductIdentifier,
	selectProductReviewSummary,
	loadReviewAISummary
} from '@product-reviews/data-access';
import { Component, inject, computed, ChangeDetectionStrategy, effect } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ReviewAISummaryResponse } from '@shared/data-access/interfaces';
import { Store } from '@ngrx/store';
import { homefieldIconAiStar, HomefieldIconLibraryModule, HomefieldIconsLibraryService } from '@dsg-tech/homefield-angular-icons';

@Component({
    selector: 'product-reviews-ai-summary',
    imports: [
        CommonModule,
        HomefieldIconLibraryModule
    ],
    templateUrl: './review-ai-summary.component.html',
    styleUrl: './review-ai-summary.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewAISummaryComponent {
	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
	private readonly store = inject(Store<AppProductReviewState>);

	private readonly productId = this.store.selectSignal(selectProductReviewProductIdentifier);
	private readonly aiReviewSummarySignal = this.store.selectSignal(selectAIReviewSummary);
	private readonly totalReviewsSignal = this.store.selectSignal(selectProductReviewSummary);

	readonly reviewAISummary = computed(() => {
		const aiSummary = this.aiReviewSummarySignal() as ReviewAISummaryResponse;
		return aiSummary?.summary ?? '';
	});

	readonly totalReviews = computed(() => {
        const summary = this.totalReviewsSignal() as ReviewSummary;
        return summary?.reviewCount ?? 0;
    });

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconAiStar
		]);

		effect(() => {
            const productId = this.productId();
            if (productId) {
                this.store.dispatch(loadReviewAISummary({ productId }));
            }
        });
	}
}